import { useMemo } from 'react';

import {
  FieldErrors,
  UseFormRegister,
  UseFormWatch,
} from 'react-hook-form';

import {
  getNextPaydays,
  IncomeDetailsFormT,
  paymentDayOptions,
  PaymentDayValueT,
} from '@consumer-frontend/nc-utils';

import { NcSelect } from '../NcSelect';

export type NcIncomeDetailsPayDayFieldsPropsT = {
  errors: FieldErrors<IncomeDetailsFormT>;
  isBiweekly: boolean;
  register: UseFormRegister<IncomeDetailsFormT>;
  watch: UseFormWatch<IncomeDetailsFormT>;
};

export const NcIncomeDetailsPayDayFields = ({
  errors,
  isBiweekly,
  register,
  watch,
}: NcIncomeDetailsPayDayFieldsPropsT): React.ReactElement => {
  const selectedPayDay = watch('payDay');
  const showNextPayday = isBiweekly && !!selectedPayDay;

  const nextPaydayOptions = useMemo(
    () => (selectedPayDay ? getNextPaydays(selectedPayDay) : []),
    [selectedPayDay],
  );

  const paymentDayValidations = {
    shouldUnregister: true,
    validate: (option?: PaymentDayValueT) => {
      return paymentDayOptions.some((day) => day.value === option);
    },
  };

  const nextPaydayValidations = {
    shouldUnregister: true,
    validate: (option?: string) => {
      return nextPaydayOptions.some((payday) => payday.value === option);
    },
  };

  return (
    <>
      <NcSelect
        {...register('payDay', paymentDayValidations)}
        errorMessage={errors.payDay && 'Select the day of the week you get paid.'}
        id="payment-day"
        label={<span className="form-label">Payment Day</span>}
        options={paymentDayOptions}
        placeholder="Select day"
      />
      {showNextPayday && (
        <NcSelect
          {...register('nextPayday', nextPaydayValidations)}
          errorMessage={errors.nextPayday && 'Select your next payday.'}
          id="next-payday"
          label={<span className="form-label">Next Payday</span>}
          options={nextPaydayOptions}
          placeholder="Select next payday"
        />
      )}
    </>
  );
};
